module.exports = "https://coinrabbit.io/_next/static/images/empty-bb1e31ad03bfc3d239f13e88986007ba.svg";